import React from 'react'
import styled from 'styled-components'
import MoreIcon from '@components/Icons/MoreIcon'

const Container = styled.div`
  width: 40px;
  height: 40px;
  position: absolute;
  display: flex;
  justify-content: flex-end;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  color: white;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(3, 3, 3, 0.4) 1%,
    rgba(176, 176, 176, 0.1) 69%,
    rgba(237, 237, 237, 0) 93%,
    rgba(255, 255, 255, 0) 100%
  );
`

const Anchor = styled.a`
  padding: 8px;
`

type Props = {
  url: string
}

function Control(props: Props) {
  const { url } = props

  return (
    <Container>
      <Anchor href={url}>
        <MoreIcon />
      </Anchor>
    </Container>
  )
}

export default Control
